<template>
  <div>
    <Head></Head>
    <NavBar activeMenu="联系我们" />
    <Banner></Banner>
    <div class="content">
      <div class="info">
        <div class="contactUs">
          <div class="lineOne"></div>
          <div class="lineTwo"></div>

          <p class="black">联系我们</p>

          <p>地址:安徽省合肥市蜀山区翡翠路1118号出版传媒广场10楼</p>
          <p>邮编: 230071</p>
          <p>纠纷处理</p>
          <p>联系电话: 0551-63533388 转1069</p>
          <p>邮箱投诉: lltsshfw@163.com</p>
          <p>全国文化和旅游市场网上举报投诉电话：12345</p>

          <p class="black topUser">用户协议</p>
          <a
            href="#/agreement"
            class="show"
            >查看</a
          >
        </div>
        <div class="app">
          <img src="../assets/app.jpg" />
          <p>乐龄听书移动端下载</p>
        </div>
        <div class="mini">
          <img src="../assets/miniCode.jpg" />
          <p>乐龄听书微信小程序</p>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from './index/Head';
import NavBar from './index/Navbar';
import Banner from './index/Banner';
import Footer from './index/Footer';

export default {
  name: 'Contact',
  components: {
    Head,
    NavBar,
    Banner,
    Footer,
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

.content {
  width: 100%;
  // height:400px;
  background-color: white;
  overflow: hidden;
}

.info {
  width: 1200px;
  // height:400px;
  margin: 0 auto;
  // background-color: red;
  overflow: hidden;
}

.contactUs {
  float: left;
  position: relative;
  // background-color: blue;
  margin-top: 47px;
  width: 485px;
  height: 308px;
  margin-left: 16px;
  margin-bottom: 54px;
}

.contactUs p {
  line-height: 30px;
}

.lineOne {
  position: absolute;
  left: -12px;
  top: 7px;
  width: 3px;
  height: 15px;
  background-color: rgb(195, 35, 20);
}

.lineTwo {
  position: absolute;
  left: -12px;
  top: 258px;
  width: 3px;
  height: 15px;
  background-color: rgb(195, 35, 20);
}

.black {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
}

.topUser {
  margin-top: 25px;
}

.show {
  color: rgb(186, 69, 63);
}

.app {
  float: left;
  width: 164px;
  height: 200px;
  margin-left: 145px;
  margin-top: 110px;
  // background-color: red;
  img {
    width: 164px;
    height: 164px;
  }
  p {
    text-align: center;
    font-size: 14px;
    margin-top: 1px;
  }
}

.mini {
  float: left;
  width: 164px;
  height: 200px;
  margin-left: 64px;
  margin-top: 110px;
  // background-color: red;
  img {
    width: 164px;
    height: 164px;
  }
  p {
    text-align: center;
    font-size: 14px;
    margin-top: 1px;
  }
}
</style>
